import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory}  from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarPracticasProfesionales from "../element/CarPracticasProfesionales";
import Menu from './Menu';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
// import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

const PracticasProfesionales = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
 
  const [practicasProfesionales, setPracticasProfesionales] = useState({});
  const [solvencia, setSolvencia] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
       dataUser.token = cred.token;
       dataUser.nombre = cred.nombre;
       dataUser.carnet = cred.carnet;
       dataUser.perfil = cred.perfil;
       dataUser.carrera = cred.carrera;

      let practicasP = GetFetch.practicasProfesionales(cred.carnet, cred.token);      
      practicasP.then((dataP) => {
        setPracticasProfesionales(dataP);
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
        setCargando(false);
        }).catch(() => setCargando(false));

      loadMenu();
    }else{
      history.push("/"); 
    }
  },[datos, history, dataUser]);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Prácticas profesionales</h2>

        {cargando ? (
          <SkeletonCard rows={4} />
        ) : practicasProfesionales.length > 0 ? (
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Empresa</th>
                      <th scope="col">Desde</th>
                      <th scope="col">Hasta</th>
                      <th scope="col">Reporte alumno</th>
                      <th scope="col">Reporte empresa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {practicasProfesionales.map((element) => (
                      <CarPracticasProfesionales
                        datos={element}
                        key={element.empresa}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : solvencia ? (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
            <b>Insolvente.</b> Regulariza tus pagos para consultar tus prácticas profesionales.
          </div>
        ) : (
          <EmptyState icon="fa-briefcase" title="Aún no tienes prácticas profesionales registradas">
            Cuando realices tus prácticas profesionales, aparecerán en esta pantalla.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default PracticasProfesionales;
